import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "@/components/container";
import {
  Toolbar,
  ToolbarActions,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle,
} from "@/partials/toolbar";
import { PageNavbar } from "@/pages/account";
import { useLayout } from "@/providers";
import ServiceProviderTab from "./components/ServiceProviderTab";
import { KeenIcon } from "@/components";
import { usePermissions } from "@/hooks/usePermissions";

const ServiceManagement = () => {
  const { currentLayout } = useLayout();
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  const hasProviderPermission = hasPermission(
    "service_provider_management_read",
  );

  const handleCreateServiceProvider = () => {
    navigate("/service-providers/create", {
      state: { from: "/service-management" },
    });
  };

  if (!hasProviderPermission) {
    return (
      <Fragment>
        <PageNavbar />
        {currentLayout?.name === "demo1-layout" && (
          <Container>
            <Toolbar>
              <ToolbarHeading>
                <ToolbarPageTitle id="service-management-heading" />
                <ToolbarDescription>
                  Manage your service providers here.
                </ToolbarDescription>
              </ToolbarHeading>
            </Toolbar>
            <div className="bg-gray-100 p-6 rounded-lg shadow-lg flex flex-col">
              <div className="text-center py-4 text-gray-500" role="alert">
                You don't have permission to view service provider management.
              </div>
            </div>
          </Container>
        )}
      </Fragment>
    );
  }

  return (
    <Fragment>
      <PageNavbar />
      {currentLayout?.name === "demo1-layout" && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <ToolbarPageTitle id="service-management-heading" />
              <ToolbarDescription>
                Manage your service providers here.
              </ToolbarDescription>
            </ToolbarHeading>
            {hasProviderPermission && (
              <ToolbarActions>
                {hasPermission("service_provider_management_read") && (
                  <button
                    type="button"
                    className="btn btn-sm btn-light flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    onClick={() => navigate("/service-providers/requests")}
                    aria-label="View service provider requests"
                  >
                    <KeenIcon
                      type="filled"
                      icon="notepad"
                      className="text-gray-500"
                    />
                    Service Provider Requests
                  </button>
                )}
                {hasPermission("service_provider_management_create") && (
                  <button
                    type="button"
                    className="btn btn-sm btn-light"
                    onClick={handleCreateServiceProvider}
                    aria-label="Add new service provider"
                  >
                    Add New Service Provider
                  </button>
                )}
              </ToolbarActions>
            )}
          </Toolbar>
        </Container>
      )}
      <ServiceProviderTab />
    </Fragment>
  );
};

export { ServiceManagement };
